
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referrer-fee",
      function () {
        return require("private-next-pages/referrer-fee.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referrer-fee"])
      });
    }
  